import { Section, Eyebrow, ChromeHeading, Card } from "../funnel";

const ITEMS = [
  ["01", "Why a 700+ score still gets you denied", "Lenders don't fund a number, they fund a profile. You'll see what underwriters actually read and the clean-up that comes before any application."],
  ["02", "Make your business look bankable", "Every underwriter asks three questions: are you real, are you stable, can you repay? You'll see how to answer all three before you apply."],
  ["03", "Stack in the right order", "How to check what you may prequalify for with a soft pull, which bank usually pulls which bureau, and why the order you apply in decides what you get."],
];

export const Learn = () => (
  <Section data-testid="learn-section">
    <div className="max-w-3xl">
      <Eyebrow>IN THIS LIVE CLASS YOU'LL LEARN</Eyebrow>
      <ChromeHeading className="mt-4 text-4xl sm:text-5xl lg:text-6xl">3 things the banks won't tell you</ChromeHeading>
    </div>
    <div className="mt-12 grid gap-5 md:grid-cols-3">
      {ITEMS.map(([n, title, body]) => (
        <Card key={n} hover className="p-7 sm:p-8" data-testid={`learn-card-${n}`}>
          <p className="font-display gold-text text-6xl leading-none">{n}</p>
          <h3 className="mt-6 text-xl font-semibold leading-snug text-[#f4efe4]">{title}</h3>
          <p className="mt-3 text-[15px] leading-relaxed text-[#b9b1a2]">{body}</p>
        </Card>
      ))}
    </div>
  </Section>
);
